import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import { useState } from "react"
import { Accordion, Col, Row, Card } from "react-bootstrap"
import { IoMdArrowDropdown } from "react-icons/io"
import faq1 from "../assets/images/faq/faq1.png"
import faq2 from "../assets/images/faq/faq2.png"
import faq3 from "../assets/images/faq/faq3.png"
import faq4 from "../assets/images/faq/faq4.png"

const FaqComp = () => {
  const query = graphql`
    {
      allStrapiFaqs {
        nodes {
          id
          category
          question
          answer
        }
      }
    }
  `

  const data = useStaticQuery(query)

  const { allStrapiFaqs: nodes } = data

  const initialFaq = nodes.nodes.filter(item => item.category === "For renters")

  const [faqs, setFaqs] = useState(initialFaq)
  const [value, setValue] = useState(0)

  const btnArr = [...new Set(nodes.nodes.map(item => item.category))]

  const colors = [faq1, faq2, faq3, faq4]

  const handleFilter = (node1, index) => {
    const filteredFaq = nodes.nodes.filter(node => node.category === node1)
    setFaqs(filteredFaq)
    setValue(index)
  }

  return (
    <section
      className="tab-outer tab-1 position-relative mt-5"
      style={{ backgroundImage: `url(${colors[value]})` }}
    >
      <div className="container sit-z-index">
        <Row className="p-fix">
          {btnArr.map((node, index) => {
            return (
              <Col lg={3} md={6} xs={6} key={index}>
                <button
                  className={`tabs  ${index === value && "active-tab-btn"}`}
                  data-toggle="tab-1"
                  data-target="tab-1-inner"
                  onClick={() => handleFilter(node, index)}
                >
                  {node}
                </button>
              </Col>
            )
          })}
          <Accordion
            className="my-4"
            defaultActiveKey="0"
            style={{ cursor: "pointer" }}
          >
            {faqs.map((faq, index) => {
              return (
                <Card key={index}>
                  <Accordion.Toggle
                    as={Card.Header}
                    eventKey={index + 1}
                    className="d-flex align-items-center justify-content-between"
                  >
                    <h6 className="rb">{faq.question}</h6>
                    <IoMdArrowDropdown />
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey={index + 1}>
                    <Card.Body>
                      <p>{faq.answer}</p>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              )
            })}
          </Accordion>
        </Row>
      </div>
    </section>
  )
}

export default FaqComp
